import { useQuery } from "@tanstack/react-query";

import { getPdfPageImages } from "@synthesis/shared-services";

export const pdfPageImageQueryKey = (fileId: string, page: number, dpi: number) => ["pdfPageImage", fileId, page, dpi] as const;

type UsePdfPageImageOptions = {
  enabled?: boolean;
  dpi?: number;
};

export const usePdfPageImage = (fileId: string | undefined, page: number, { enabled = true, dpi = 300 }: UsePdfPageImageOptions = {}) => {
  return useQuery({
    queryKey: pdfPageImageQueryKey(fileId ?? "", page, dpi),
    queryFn: ({ signal }) => getPdfPageImages(fileId!, { page, dpi }, { signal }),
    enabled: enabled && !!fileId && page > 0,
    staleTime: Infinity,
    gcTime: 10 * 60 * 1000,
  });
};
